import { useRef } from 'react';
import { useOnce } from './useOnce';

export function useIsUnmounted() {
  let isUnmounted = useRef(false);
  useOnce(() => () => void (isUnmounted.current = true));
  return isUnmounted;
}
